import { render, staticRenderFns } from "./vsImage.vue?vue&type=template&id=347c0686&"
import script from "./vsImage.vue?vue&type=script&lang=js&"
export * from "./vsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsImage.vue"
export default component.exports